import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { Actions } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Auth',
  setup(__props) {

const store = useStore();
const router = useRouter();

const loggedIn = computed(() => store.state.loggedIn);

onMounted(() => {
  store.dispatch(Actions.GetAuth);
});

const logout = (evt: Event) => {
  store.dispatch(Actions.Logout);
  router.push('/login');
  evt.preventDefault();
};

return (_ctx: any,_cache: any) => {
  return (_unref(loggedIn))
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: "/logout",
        class: "logout",
        onClick: logout
      }, "Log out"))
    : _createCommentVNode("", true)
}
}

})